class BeforeAfterComparison {
  constructor(container) {
    this.container = container;
    this.comparisons = [];
    this.init();
  }

  init() {
    const separators = this.container.querySelectorAll('[data-draggable]');
    separators.forEach(separator => this.initDraggable(separator));
  }

  initDraggable(separator) {
    const imagesContainer = separator.closest('.images');
    const beforeElement = imagesContainer.querySelector('.before');
    
    let isDragging = false;
    let startX = 0;
    let currentX = 50;

    const updatePosition = (clientX) => {
      const rect = imagesContainer.getBoundingClientRect();
      const x = clientX - rect.left;
      const percent = Math.max(0, Math.min(100, (x / rect.width) * 100));
      
      currentX = percent;
      separator.style.left = `${percent}%`;
      beforeElement.style.clipPath = `inset(0 ${100 - percent}% 0 0)`;
    };

    // Mouse events
    separator.addEventListener('mousedown', (e) => {
      isDragging = true;
      startX = e.clientX;
      separator.style.cursor = 'grabbing';
      e.preventDefault();
    });

    document.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      updatePosition(e.clientX);
    });

    document.addEventListener('mouseup', () => {
      if (isDragging) {
        isDragging = false;
        separator.style.cursor = 'ew-resize';
      }
    });

    // Touch events
    separator.addEventListener('touchstart', (e) => {
      isDragging = true;
      startX = e.touches[0].clientX;
      e.preventDefault();
    });

    document.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      updatePosition(e.touches[0].clientX);
      e.preventDefault();
    }, { passive: false });

    document.addEventListener('touchend', () => {
      isDragging = false;
    });

    // Initialize position
    updatePosition(imagesContainer.getBoundingClientRect().left + (imagesContainer.offsetWidth / 2));
  }
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('.before-after-section');
  containers.forEach(container => new BeforeAfterComparison(container));
});

// Reinitialize on Shopify section load
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const container = event.target.querySelector('.before-after-section');
    if (container) new BeforeAfterComparison(container);
  });
}